<script>
	import { Router, Route, Link } from 'svelte-routing';
	import Landing from './routes/Landing.svelte';
	import Catalogue from './routes/Catalogue.svelte';

	import "bulma/css/bulma.min.css";
</script>

<Router>
	<div class="page-container">
		<main>
			<Route path="/" component={Landing} />
			<Route path="catalogue" component={Catalogue} />
		</main>

		<footer class="footer">
			<div class="contact-wrap">
				<div class="contact">
					Want to know more? <a href="mailto:elixir.support@ut.ee?subject=One-Stop-Shop">Contact us.</a>
				</div>
			</div>
			<div class="logos">
				<a href="https://elixir.ut.ee/"><img class="elixir-ee_logo" src="/images/logos/elixir-ee.png" alt="ELIXIR Estonia"></a>
				<a href="https://cs.ut.ee/"><img class="ut-cs_logo" src="/images/logos/ut.svg" alt="University of Tartu, Institute of Computer Science"></a>
				<a href="https://www.sanger.ac.uk/"><img class="sanger_logo" src="/images/logos/sanger.svg" alt="Wellcome Sanger Institute"></a>
			</div>
		</footer>
	</div>
</Router>

<style>

	.page-container {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
	main {
		flex-grow: 1;
	}

	.footer {
		padding: 0px;
	}

	.contact-wrap {
		padding: 0 20px;
	}

	.contact {
		text-align: center;
		max-width: 1160px;
		padding: 0 50px;
		margin: 0 auto;
	}

	@media (max-width: 800px) {
		.contact {
			padding: 0;
		}
	}

	.logos {
		background: linear-gradient(to right, #597fba, #2d3a87);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 20px;
		padding: 20px;
		height: 100%;
	}

	@media (max-width: 800px) {
		.logos {
			flex-direction: column;
		}
	}

	.elixir-ee_logo {
		height: 70px;
	}
	.sanger_logo {
		height: 70px;
	}
	.ut-cs_logo {
		height: 50px;
	}

</style>